import { render, staticRenderFns } from "./log-out-btn.vue?vue&type=template&id=cfd9a0d6"
import script from "./log-out-btn.vue?vue&type=script&lang=js"
export * from "./log-out-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports